<template>
	<el-dialog :visible.sync="visible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" width="550px">
		<span slot="title" class="dialog-title">
			<span>{{ showTitle }}</span>
			<img src="@/assets/images/close.png" alt="" @click="visible = false" />
		</span>
		<div class="content">
			<el-row :gutter="24">
				<el-button :loading="loading" class="submit-btn mr20" @click="handleExport">直接导出</el-button>
				<el-button :loading="asyncLoading" class="submit-btn" @click="handleAsyncExport">后台导出</el-button>
			</el-row>
		</div>
		<div class="tip">
			<span class="red-asterisk">*</span>
			后台导出是通过邮件的方式下载。
		</div>
	</el-dialog>
</template>

<script>
import { followUpStatusOptions } from "@/constant/options";
import { debounce } from "@/utils/debounce";

export default {
	name: "exportSelection",
	props: {},
	data() {
		return {
			visible: false,
			loading: false,
			asyncLoading: false,
			showTitle: "导出选择",
			data: {},
		};
	},
	methods: {
		show(type, data) {
			this.loading = false;
			this.$refs.form && this.$refs.form.resetFields();
			if (type === "case") {
				this.showTitle = "案例管理导出";
			} else {
				this.showTitle = "内容管理导出";
			}
			this.data = data;
			this.$nextTick(() => {
				this.visible = true;
			});
		},
		handleExport: debounce(function () {
			if (this.visible === false) {
				return;
			}
			this.loading = true;
			let that = this;
			that.$request.post("bbsExport", true, that.data, function (res) {
				that.visible = false;
				if (res.code == "0") {
					const linkNode = document.createElement("a");
					linkNode.style.display = "none";
					linkNode.href = res.data;
					document.body.appendChild(linkNode);
					linkNode.click(); //模拟在按钮上的一次鼠标单击
					URL.revokeObjectURL(linkNode.href); // 释放URL 对象
					document.body.removeChild(linkNode);
				} else {
					that.$message.error(res.msg);
				}
			});
		}, 1000),
		handleAsyncExport: debounce(function () {
			if (this.visible === false) {
				return;
			}
			// this.asyncLoading = true;
			this.visible = false;
			this.$message.success("导出完成，稍等请检查您的邮件。");

			let that = this;
			that.$request.post(
				"bbsSyncExport",
				false,
				that.data,
				function (res) {
					// that.asyncLoading = false;
					// that.$message.success("导出完成，稍等请检查您的邮件。");
					// that.visible = false;
				},
				function () {
					// that.asyncLoading = false;
					// that.$message.error("导出失败！");
				},
			);
		}, 1000),
	},
};
</script>

<style scoped lang="scss">
.dialog-title {
	display: block;
	text-align: center;
	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}
	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}

.content {
	text-align: center;
	margin-top: 15px;
	margin-bottom: 15px;
}

.el-form-item {
	margin-bottom: 18px;
	.el-select {
		width: 100%;
	}
}
.submit-btn {
	background-color: #117ffc;
	color: #fff;
	border-color: #117ffc;
	width: 120px;
	height: 40px;
	line-height: 13px;
	border-radius: 4px;
	font-size: 15px;
}

.tip {
	text-align: center;
	padding-top: 10px;
}

.red-asterisk {
	color: red;
}
</style>
